/**
 * Reminder and meeting notifications. On desktop they go through host.shell.showNotification; on the web we use the
 * Notification API when permitted, otherwise a toast. Hub only notifies the user, it never contacts anyone.
 */
import { useEffect } from "react";
import { getHost } from "@/engine/transport";
import { invokeEngine } from "@/engine/hooks";
import { subscribeEngine } from "@/engine/transport";
import { toast } from "@/ui";

export async function notify(title: string, body: string, data: Record<string, unknown> = {}) {
  const host = getHost();
  if (host?.shell?.showNotification) {
    await host.shell.showNotification(title, body, data).catch(() => toast(`${title}: ${body}`));
    return;
  }
  if (typeof Notification !== "undefined" && Notification.permission === "granted") {
    try {
      new Notification(title, { body });
      return;
    } catch {
      // fall through to a toast
    }
  }
  toast(`${title}: ${body}`);
}

export function useNativeNotifications() {
  useEffect(() => {
    return subscribeEngine((n) => {
      if (n.method !== "remindersDue") return;
      invokeEngine("getPendingReminders", {})
        .then((rs) => {
          const due = rs.filter((r) => n.params.reminderIds.includes(r.id));
          for (const r of due) notify(r.title ?? "Reminder", r.contact ? `About ${r.contact.displayName}` : "", { reminderId: r.id, contactId: r.contactId });
        })
        .catch(() => undefined);
    });
  }, []);
}
